[
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
    "fileMatch": ["a://b/EC_Public.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
      "title": "EC_Public",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "The key type, which is always 'EC' for Elliptic Curve keys."
        },
        "crv": {
          "type": "string",
          "description": "The algorithm intended for use with the key, such as 'ES256'."
        },
        "x": {
          "type": "string",
          "description": "The x coordinate of the EC public key."
        },
        "y": {
          "type": "string",
          "description": "The y coordinate of the EC public key."
        }
      },
      "required": ["kty", "crv", "x", "y"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
    "fileMatch": ["a://b/JwksResponseDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
      "title": "JwksResponseDto",
      "type": "object",
      "properties": {
        "keys": {
          "description": "An array of EC public keys in JWK format.",
          "type": "array",
          "items": {
            "$ref": "./EC_Public.schema.json"
          }
        }
      },
      "required": ["keys"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
    "fileMatch": ["a://b/RoleDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
      "title": "RoleDto",
      "type": "object",
      "properties": {
        "role": {
          "enum": [
            "presentation:manage",
            "presentation:offer",
            "issuance:manage",
            "issuance:offer",
            "clients:manage",
            "tenants:manage"
          ],
          "type": "string",
          "description": "OAuth2 roles",
          "example": "issuance:manage"
        }
      },
      "required": ["role"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
    "fileMatch": ["a://b/ClientCredentialsDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
      "title": "ClientCredentialsDto",
      "type": "object",
      "properties": {
        "client_id": {
          "type": "string"
        },
        "client_secret": {
          "type": "string"
        }
      },
      "required": ["client_id", "client_secret"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
    "fileMatch": ["a://b/TokenResponse.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
      "title": "TokenResponse",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string"
        },
        "token_type": {
          "type": "string"
        },
        "expires_in": {
          "type": "number"
        }
      },
      "required": ["access_token", "token_type", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
    "fileMatch": ["a://b/TenantEntity.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
      "title": "TenantEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "status": {
          "type": "string",
          "description": "The current status of the tenant."
        },
        "clients": {
          "description": "The clients associated with the tenant.",
          "type": "array",
          "items": {
            "$ref": "./ClientEntity.schema.json"
          }
        }
      },
      "required": ["id", "name", "status", "clients"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
    "fileMatch": ["a://b/ClientEntity.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
      "title": "ClientEntity",
      "type": "object",
      "properties": {
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "tenantId": {
          "type": "string",
          "description": "The unique identifier for the tenant that the client belongs to. Only null for accounts that manage tenants, that do not belong to a client"
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:offer",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage"
            ]
          }
        },
        "tenant": {
          "description": "The tenant that the client belongs to.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        }
      },
      "required": ["clientId", "roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
    "fileMatch": ["a://b/CreateTenantDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
      "title": "CreateTenantDto",
      "type": "object",
      "properties": {
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:offer",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage"
            ]
          }
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        }
      },
      "required": ["id", "name"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
    "fileMatch": ["a://b/ClientSecretResponseDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
      "title": "ClientSecretResponseDto",
      "type": "object",
      "properties": {
        "secret": {
          "type": "string"
        }
      },
      "required": ["secret"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
    "fileMatch": ["a://b/UpdateClientDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
      "title": "UpdateClientDto",
      "type": "object",
      "properties": {
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "type": "array",
          "description": "The roles assigned to the client.",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:offer",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage"
            ]
          }
        }
      },
      "required": ["roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
    "fileMatch": ["a://b/CreateClientDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
      "title": "CreateClientDto",
      "type": "object",
      "properties": {
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "type": "array",
          "description": "The roles assigned to the client.",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:offer",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage"
            ]
          }
        }
      },
      "required": ["clientId", "roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertEntity.schema.json",
    "fileMatch": ["a://b/CertEntity.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertEntity.schema.json",
      "title": "CertEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for the key."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "crt": {
          "type": "string",
          "description": "Certificate in PEM format."
        },
        "type": {
          "type": "object",
          "description": "Type of the certificate (access or signing)."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        }
      },
      "required": ["id", "tenantId", "tenant", "crt", "type", "createdAt", "updatedAt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Key.schema.json",
    "fileMatch": ["a://b/Key.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Key.schema.json",
      "title": "Key",
      "type": "object",
      "properties": {
        "kid": {
          "type": "string"
        },
        "kty": {
          "type": "string"
        },
        "x": {
          "type": "string"
        },
        "y": {
          "type": "string"
        },
        "crv": {
          "type": "string"
        },
        "d": {
          "type": "string"
        },
        "alg": {
          "type": "string"
        }
      },
      "required": ["kid", "kty", "x", "y", "crv", "d", "alg"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyImportDto.schema.json",
    "fileMatch": ["a://b/KeyImportDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyImportDto.schema.json",
      "title": "KeyImportDto",
      "type": "object",
      "properties": {
        "privateKey": {
          "description": "The private key in JWK format.",
          "allOf": [
            {
              "$ref": "./Key.schema.json"
            }
          ]
        },
        "crt": {
          "type": "string",
          "description": "Optional certificate in PEM format."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      },
      "required": ["privateKey"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateKeyDto.schema.json",
    "fileMatch": ["a://b/UpdateKeyDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateKeyDto.schema.json",
      "title": "UpdateKeyDto",
      "type": "object",
      "properties": {
        "crt": {
          "type": "string",
          "description": "Optional certificate in PEM format."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigNone.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
      "title": "WebHookAuthConfigNone",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["none"]
        }
      },
      "required": ["type"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
    "fileMatch": ["a://b/ApiKeyConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
      "title": "ApiKeyConfig",
      "type": "object",
      "properties": {
        "headerName": {
          "type": "string",
          "description": "The name of the header where the API key will be sent."
        },
        "value": {
          "type": "string",
          "description": "The value of the API key to be sent in the header."
        }
      },
      "required": ["headerName", "value"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigHeader.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
      "title": "WebHookAuthConfigHeader",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["apiKey"]
        },
        "config": {
          "description": "Configuration for API key authentication.\nThis is required if the type is 'apiKey'.",
          "allOf": [
            {
              "$ref": "./ApiKeyConfig.schema.json"
            }
          ]
        }
      },
      "required": ["type", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
    "fileMatch": ["a://b/WebhookConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
      "title": "WebhookConfig",
      "type": "object",
      "properties": {
        "auth": {
          "description": "Optional authentication configuration for the webhook.\nIf not provided, no authentication will be used.",
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "url": {
          "type": "string",
          "description": "The URL to which the webhook will send notifications."
        }
      },
      "required": ["auth", "url"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
    "fileMatch": ["a://b/PresentationRequest.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
      "title": "PresentationRequest",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "The type of response expected from the presentation request.",
          "enum": ["qrcode", "uri", "dc-api"]
        },
        "requestId": {
          "type": "string",
          "description": "Identifier of the presentation configuration"
        },
        "webhook": {
          "description": "Webhook configuration to receive the response.\nIf not provided, the configured webhook from the configuration will be used.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "redirectUri": {
          "type": "string",
          "description": "Optional redirect URI to which the user-agent should be redirected after the presentation is completed."
        }
      },
      "required": ["response_type", "requestId"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
    "fileMatch": ["a://b/OfferResponse.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
      "title": "OfferResponse",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "session": {
          "type": "string"
        }
      },
      "required": ["uri", "session"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Claim.schema.json",
    "fileMatch": ["a://b/Claim.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Claim.schema.json",
      "title": "Claim",
      "type": "object",
      "properties": {
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["path"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
    "fileMatch": ["a://b/TrustedAuthorityQuery.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
      "title": "TrustedAuthorityQuery",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["aki", "etsi_tl", "openid_federation"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
    "fileMatch": ["a://b/CredentialQuery.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
      "title": "CredentialQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "multiple": {
          "type": "boolean"
        },
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./Claim.schema.json"
          }
        },
        "meta": {
          "type": "object"
        },
        "trusted_authorities": {
          "type": "array",
          "items": {
            "$ref": "./TrustedAuthorityQuery.schema.json"
          }
        }
      },
      "required": ["id", "format", "meta"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
    "fileMatch": ["a://b/CredentialSetQuery.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
      "title": "CredentialSetQuery",
      "type": "object",
      "properties": {
        "options": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": {
          "type": "boolean"
        }
      },
      "required": ["options"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
    "fileMatch": ["a://b/DCQL.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
      "title": "DCQL",
      "type": "object",
      "properties": {
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_set": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateRequest.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
      "title": "RegistrationCertificateRequest",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Identifier of the registration certificate that got issued."
        },
        "body": {
          "type": "object",
          "description": "The body of the registration certificate request containing the necessary details."
        }
      },
      "required": ["body"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
    "fileMatch": ["a://b/PresentationAttachment.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
      "title": "PresentationAttachment",
      "type": "object",
      "properties": {
        "format": {
          "type": "string"
        },
        "data": {
          "type": "object"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["format", "data"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
    "fileMatch": ["a://b/PresentationConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
      "title": "PresentationConfig",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "registrationCert": {
          "description": "The registration certificate request containing the necessary details.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "description": "Optional webhook URL to receive the response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        },
        "attached": {
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        }
      },
      "required": ["id", "tenant", "dcql_query", "createdAt", "updatedAt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigCreateDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
      "title": "PresentationConfigCreateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "registrationCert": {
          "description": "The registration certificate request containing the necessary details.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "description": "Optional webhook URL to receive the response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "attached": {
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        }
      },
      "required": ["id", "dcql_query"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
    "fileMatch": ["a://b/AuthorizeQueries.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
      "title": "AuthorizeQueries",
      "type": "object",
      "properties": {
        "issuer_state": {
          "type": "string"
        },
        "response_type": {
          "type": "string"
        },
        "client_id": {
          "type": "string"
        },
        "redirect_uri": {
          "type": "string"
        },
        "resource": {
          "type": "string"
        },
        "scope": {
          "type": "string"
        },
        "code_challenge": {
          "type": "string"
        },
        "code_challenge_method": {
          "type": "string"
        },
        "dpop_jkt": {
          "type": "string"
        },
        "request_uri": {
          "type": "string"
        },
        "auth_session": {
          "type": "string"
        },
        "state": {
          "type": "string"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
    "fileMatch": ["a://b/OfferRequestDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
      "title": "OfferRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "enum": ["qrcode", "uri", "dc-api"],
          "type": "string",
          "examples": [
            {
              "value": "qrcode"
            }
          ],
          "description": "The type of response expected for the offer request."
        },
        "claims": {
          "type": "object",
          "description": "Override the default values for the credential claims.",
          "properties": {},
          "examples": [
            {
              "pid": {
                "given_name": "ERIKA",
                "family_name": "MUSTERMANN"
              }
            }
          ]
        },
        "flow": {
          "description": "The flow type for the offer request.",
          "enum": ["authorization_code", "pre_authorized_code"],
          "type": "string"
        },
        "tx_code": {
          "type": "string",
          "description": "Transaction code for pre-authorized code flow."
        },
        "credentialConfigurationIds": {
          "description": "List of credential configuration ids to be included in the offer.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "claimWebhook": {
          "description": "Webhooks to fetch the claims dynamically.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notifyWebhook": {
          "description": "Webhook to notify about the status of the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["response_type", "flow", "credentialConfigurationIds"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Session.schema.json",
    "fileMatch": ["a://b/Session.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Session.schema.json",
      "title": "Session",
      "type": "object",
      "properties": {
        "status": {
          "description": "Status of the session.",
          "enum": ["active", "fetched", "completed", "expired", "failed"],
          "type": "string"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the session."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was last updated."
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request is set to expire."
        },
        "useDcApi": {
          "type": "boolean",
          "description": "Flag indicating whether to use the DC API for the presentation request."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for multi-tenancy support."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authorization_code": {
          "type": "string"
        },
        "request_uri": {
          "type": "string",
          "description": "Request URI from the authorization request."
        },
        "auth_queries": {
          "description": "Authorization queries associated with the session.",
          "allOf": [
            {
              "$ref": "./AuthorizeQueries.schema.json"
            }
          ]
        },
        "nonce": {
          "type": "string",
          "description": "Nonce used for the OID4VCI flow."
        },
        "offer": {
          "description": "Credential offer object containing details about the credential offer or presentation request.",
          "type": "object"
        },
        "offerUrl": {
          "type": "string",
          "description": "Offer URL for the credential offer."
        },
        "credentialPayload": {
          "description": "Credential payload containing the offer request details.",
          "allOf": [
            {
              "$ref": "./OfferRequestDto.schema.json"
            }
          ]
        },
        "claimsWebhook": {
          "description": "Webhook configuration to send result and may receive further information.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notifyWebhook": {
          "description": "Webhook configuration to send the result of the notification response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notifications": {
          "description": "Notifications associated with the session.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "requestId": {
          "type": "string"
        },
        "requestUrl": {
          "type": "string",
          "description": "The URL of the presentation auth request."
        },
        "requestObject": {
          "type": "string",
          "description": "Signed presentation auth request."
        },
        "credentials": {
          "description": "Verified credentials from the presentation process.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "vp_nonce": {
          "type": "string",
          "description": "Noncce from the Verifiable Presentation request."
        },
        "redirectUri": {
          "type": "string",
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        }
      },
      "required": [
        "status",
        "id",
        "createdAt",
        "updatedAt",
        "useDcApi",
        "tenantId",
        "tenant",
        "notifications"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
    "fileMatch": ["a://b/AuthorizationResponse.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
      "title": "AuthorizationResponse",
      "type": "object",
      "properties": {
        "response": {
          "type": "string",
          "description": "The response string containing the authorization details."
        },
        "sendResponse": {
          "type": "boolean",
          "description": "When set to true, the authorization response will be sent to the client."
        }
      },
      "required": ["response"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
    "fileMatch": ["a://b/StatusUpdateDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
      "title": "StatusUpdateDto",
      "type": "object",
      "properties": {
        "sessionId": {
          "type": "string",
          "description": "The session ID of the user"
        },
        "credentialConfigurationId": {
          "type": "string",
          "description": "The ID of the credential configuration\nThis is optional, if not provided, all credentials will be revoked of the session."
        },
        "status": {
          "type": "number",
          "description": "The status of the credential\n0 = valid, 1 = revoked, 2 = suspended"
        }
      },
      "required": ["sessionId", "status"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
    "fileMatch": ["a://b/NotificationRequestDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
      "title": "NotificationRequestDto",
      "type": "object",
      "properties": {
        "notification_id": {
          "type": "string"
        },
        "event": {
          "type": "object"
        }
      },
      "required": ["notification_id", "event"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
    "fileMatch": ["a://b/ParResponseDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
      "title": "ParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI for the Pushed Authorization Request."
        },
        "expires_in": {
          "type": "number",
          "description": "The expiration time for the request URI in seconds."
        }
      },
      "required": ["request_uri", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
    "fileMatch": ["a://b/ClaimsQuery.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
      "title": "ClaimsQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "values": {
          "type": "array",
          "items": {
            "type": "object"
          }
        }
      },
      "required": ["id", "path"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
    "fileMatch": ["a://b/PolicyCredential.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
      "title": "PolicyCredential",
      "type": "object",
      "properties": {
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_sets": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
    "fileMatch": ["a://b/AttestationBasedPolicy.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
      "title": "AttestationBasedPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["attestationBased"]
        },
        "values": {
          "type": "array",
          "items": {
            "$ref": "./PolicyCredential.schema.json"
          }
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
    "fileMatch": ["a://b/NoneTrustPolicy.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
      "title": "NoneTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["policy"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
    "fileMatch": ["a://b/AllowListPolicy.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
      "title": "AllowListPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["allowList"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
    "fileMatch": ["a://b/RootOfTrustPolicy.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
      "title": "RootOfTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["rootOfTrust"]
        },
        "values": {
          "type": "string"
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
    "fileMatch": ["a://b/EmbeddedDisclosurePolicy.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
      "title": "EmbeddedDisclosurePolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        }
      },
      "required": ["policy"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
    "fileMatch": ["a://b/DisplayImage.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
      "title": "DisplayImage",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        }
      },
      "required": ["uri"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Display.schema.json",
    "fileMatch": ["a://b/Display.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Display.schema.json",
      "title": "Display",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "background_color": {
          "type": "string"
        },
        "text_color": {
          "type": "string"
        },
        "background_image": {
          "$ref": "./DisplayImage.schema.json"
        },
        "logo": {
          "$ref": "./DisplayImage.schema.json"
        }
      },
      "required": ["name", "description", "locale"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
    "fileMatch": ["a://b/IssuerMetadataCredentialConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
      "title": "IssuerMetadataCredentialConfig",
      "type": "object",
      "properties": {
        "format": {
          "type": "string"
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./Display.schema.json"
          }
        },
        "scope": {
          "type": "string"
        }
      },
      "required": ["format", "display"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VCT.schema.json",
    "fileMatch": ["a://b/VCT.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VCT.schema.json",
      "title": "VCT",
      "type": "object",
      "properties": {
        "vct": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "extends": {
          "type": "string"
        },
        "extends#integrity": {
          "type": "string"
        },
        "schema_uri": {
          "type": "string"
        },
        "schema_uri#integrity": {
          "type": "string"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SchemaResponse.schema.json",
    "fileMatch": ["a://b/SchemaResponse.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SchemaResponse.schema.json",
      "title": "SchemaResponse",
      "type": "object",
      "properties": {
        "$schema": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "properties": {
          "type": "object"
        },
        "required": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        }
      },
      "required": ["$schema", "type", "properties"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
    "fileMatch": ["a://b/CredentialConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
      "title": "CredentialConfig",
      "type": "object",
      "properties": {
        "embeddedDisclosurePolicy": {
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "claims": {
          "type": "object"
        },
        "claimsWebhook": {
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notificationWebhook": {
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "disclosureFrame": {
          "type": "object"
        },
        "vct": {
          "$ref": "./VCT.schema.json"
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyId": {
          "type": "string"
        },
        "key": {
          "$ref": "./CertEntity.schema.json"
        },
        "statusManagement": {
          "type": "boolean"
        },
        "lifeTime": {
          "type": "number"
        },
        "schema": {
          "$ref": "./SchemaResponse.schema.json"
        }
      },
      "required": ["id", "tenant", "config", "key"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
    "fileMatch": ["a://b/CredentialConfigCreate.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
      "title": "CredentialConfigCreate",
      "type": "object",
      "properties": {
        "embeddedDisclosurePolicy": {
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "claims": {
          "type": "object"
        },
        "claimsWebhook": {
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notificationWebhook": {
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "disclosureFrame": {
          "type": "object"
        },
        "vct": {
          "$ref": "./VCT.schema.json"
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyId": {
          "type": "string"
        },
        "statusManagement": {
          "type": "boolean"
        },
        "lifeTime": {
          "type": "number"
        },
        "schema": {
          "$ref": "./SchemaResponse.schema.json"
        }
      },
      "required": ["id", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodNone.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
      "title": "AuthenticationMethodNone",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["method"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
    "fileMatch": ["a://b/AuthenticationUrlConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
      "title": "AuthenticationUrlConfig",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "The URL used in the OID4VCI authorized code flow.\nThis URL is where users will be redirected for authentication."
        },
        "webhook": {
          "description": "Optional webhook configuration for authentication callbacks",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["url"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodAuth.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
      "title": "AuthenticationMethodAuth",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["auth"]
        },
        "config": {
          "$ref": "./AuthenticationUrlConfig.schema.json"
        }
      },
      "required": ["method", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
    "fileMatch": ["a://b/PresentationDuringIssuanceConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
      "title": "PresentationDuringIssuanceConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "Link to the presentation configuration that is relevant for the issuance process"
        }
      },
      "required": ["type"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodPresentation.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
      "title": "AuthenticationMethodPresentation",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["presentationDuringIssuance"]
        },
        "config": {
          "$ref": "./PresentationDuringIssuanceConfig.schema.json"
        }
      },
      "required": ["method", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
    "fileMatch": ["a://b/DisplayLogo.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
      "title": "DisplayLogo",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "alt_text": {
          "type": "string"
        }
      },
      "required": ["uri"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
    "fileMatch": ["a://b/DisplayInfo.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
      "title": "DisplayInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "logo": {
          "$ref": "./DisplayLogo.schema.json"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
    "fileMatch": ["a://b/IssuanceConfig.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
      "title": "IssuanceConfig",
      "type": "object",
      "properties": {
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "notifyWebhook": {
          "description": "Webhook to send the result of the notification response",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        }
      },
      "required": ["tenant", "display", "createdAt", "updatedAt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
    "fileMatch": ["a://b/IssuanceDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
      "title": "IssuanceDto",
      "type": "object",
      "properties": {
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "notifyWebhook": {
          "description": "Webhook to send the result of the notification response",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        }
      },
      "required": ["display"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
    "fileMatch": ["a://b/FileUploadDto.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
      "title": "FileUploadDto",
      "type": "object",
      "properties": {
        "file": {
          "type": "string",
          "format": "binary"
        }
      },
      "required": ["file"]
    }
  }
]
